import { inject, Injectable } from '@angular/core';
import { ZitadelStartExtAuthModel } from '../models/zitadel-start-ext-auth.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ZitadelStartExtAuthResponseModel } from '../models/zitadel-start-ext-auth-response.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ExternalAuthService {
  private readonly httpClient = inject(HttpClient);

  public getLoginUrl(model: ZitadelStartExtAuthModel): Observable<ZitadelStartExtAuthResponseModel> {
    return this.httpClient.post<ZitadelStartExtAuthResponseModel>(`${environment.api}/externalAuth/loginUrl`, model);
  }

  /**
   * Builds the SWITCH edu-ID login request and redirects the browser to the idp.
   * Returns an Observable that completes after initiating the redirect.
   * forceLogin makes the idp authenticate again instead of reusing its session.
   */
  public redirectToSwitchEduIdLogin(returnUrl?: string, forceLogin = false): Observable<void> {
    const successUrl = returnUrl ?? window.location.origin + environment.externalLogin.successUrl;
    const model: ZitadelStartExtAuthModel = {
      idpId: environment.externalLogin.idpIds.eduId,
      successUrl,
      failureUrl: environment.externalLogin.failureUrl,
      forceLogin
    };

    return new Observable<void>((observer) => {
      this.getLoginUrl(model).subscribe({
        next: (response) => {
          window.location.href = response.authUrl;
          observer.next();
          observer.complete();
        },
        error: (err: unknown) => { observer.error(err); }
      });
    });
  }
}
